export default function Logout({ color = "#79778E" }) {
  return (


    <svg width="2.4rem" height="2.4rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 17L15 12L10 7" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15 12L3 12" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M14 3L18 3C19.1 3 20 3.9 20 5L20 19C20 20.1 19.1 21 18 21L14 21" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>


  )
}